<template>
  <div
    class="ycmdcbl"
  >
    <label 
      class="v-label v-label--active theme--light fs-10"
      v-if="label"
    >{{label}}</label>

    <v-container
      class="pa-0 ma-0"  
      v-if="horizontal"    
      :style="listStyle"  
      >        

        <v-row
          class="ma-0 pa-0"
          style="max-height: 24px;"               >
          <v-col
              class="pa-0 ma-0 shrink"
              v-for="(item,i) in items"
              :key="`col_${item.id}_${i}`"              
          > 
            <v-checkbox
              class="ma-0 pa-0"  
              v-model="localValues[item.id]"
              style="max-height: 24px;"
              hide-details
              dense
              :ripple="false"
              :disabled="disabled"
            >
            <template v-slot:label>

              <span v-if="item.html"
                v-html="item.html"
              ></span>

              <span
                class="fs-12 font-weight-bold"
                v-else
                >
                {{item.name}}
              </span>

            </template>
            </v-checkbox>
          </v-col>
        </v-row>
    </v-container>

    <template
      v-else
    >
   
      <div v-if="chips">
        <v-chip
          v-for="chip in itemChips"
          :key="`cblchip_${chip.id}`"
          :color="chip.chipColor"
          :text-color="chip.chipTextColor"
          close
          @click:close="unSelectChip(chip)"
        >
          {{chip.chip}}
        </v-chip>

      </div>

      <v-list
        select-strategy="classic"
        dense
        class="pa-0 ma-0"
        :style="listStyle"          
      >
        <v-list-item
          v-for="(item,i) in items"
          :key="`key_${item.id}_${i}`"
          :value="item.id"
          class="pa-0 ma-0"
          >

            <v-list-item-action
              class="pa-0 ma-0"
            >
              <v-checkbox
                v-model="localValues[item.id]"
                hide-details
                dense
                :ripple="false"
                :disabled="disabled"
              ></v-checkbox>
            </v-list-item-action>

          <v-list-item-title>
            <span v-if="item.html"
                v-html="item.html"
            ></span>
            <span v-else
            >
              {{ item.name }}
            </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </div>    
</template>

<script>

export default {

  props: {
    value: {
      default: () => [],
      type: Array
    },
    items: {
      default: () => [],
      type: Array
    },
    label: {
      default: '',
      type: String
    },
    horizontal: {
      default: false,
      type: Boolean
    },
    chips: {
      default: false,
      type: Boolean
    },    
    width: {
      default: '',
      type: String
    },
    height: {
      default: '',
      type: String
    },  
    outlined: {
        default: false,
        type: Boolean
    },  
    disabled: {
        default: false,
        type: Boolean
    },          
  },
  data: () => ({
    localValues: {},
    itemChips: []
  }),
  methods: {
    unSelectChip (chip) {
      this.localValues[chip.id] = false
    },
    loadItemChips () {
      let arr = []
      if (this.localValues) {
        for (let lvid in this.localValues) {
          if (this.localValues[lvid]) {
            let item = this.itemMap[lvid]
            if (item) {
              arr.push(item)
            }
          }
        }
      }

      this.itemChips = arr

    },    
    setValue (arr) {
      let current = {}
      
      for (let id in this.localValues) {
        if (this.localValues[id]) {
          current[id] = true
        }
      }

      let examined = {}

      if (arr && arr.length) {
        arr.map(a => {
          if (current[a]) {
            //same
          } else {
            this.$set(this.localValues,a,true)
          }

          examined[a] = true
          
        })
      }
    
      for (let id in this.localValues) {
        if (!examined[id]) {
          this.$set(this.localValues,id,false)
        }
      }

    }
  },
  computed: {
    itemMap () {
      let map = {}
      if (this.items && this.items.length) {
        this.items.map(i => {
          map[i.id] = i
        })
      }

      return map
    },
    listStyle () {
      let style=''
      if (this.width) {
        style = `width: ${this.width};`
        if (this.horizontal) {
          style += 'overflow-x: auto;'
        }
      }
      if (this.height) {
        style += `height: ${this.height};`
        if (!this.horizontal) {
          style += 'overflow-y: auto;'
        }
      }

      if (this.outlined) {
        style+="border: 1px solid;"        
      }

      
      return style 
    },

  },
  watch: {
    localValues: {
        handler (val, oldVal) {
          let arr = []
          for (let id in val) {
            if (val[id]) {
              arr.push(id)
            }
          }
          this.$emit('input', arr)
          this.$nextTick(() => {
            this.loadItemChips()
          })
        },
        deep: true
    },
    value(newValue, oldValue) {
      this.setValue(newValue)
      this.loadItemChips()
    }
  },
  mounted () {
    if (this.value && this.value.length) {
      this.value.map(v => {
        this.$set(this.localValues,v,true)
      })
    }
  }
}
</script>
<style>

div.ycmdcbl div.v-input--selection-controls__ripple{
    margin: 0px;
}
div.ycmdcbl div.v-input--selection-controls__input{
    max-height: 24px;
}
div.ycmdcbl div.v-list-item{
    min-height: 12px;
}



</style>
